import { FlowModalMode } from '../flowModal.types';

export const modalTitle: Record<FlowModalMode, string> = {
  rename: 'Rename flow',
};
